import NextLink from 'next/link';
import React from 'react';

type LinkProps = Omit<React.ComponentProps<typeof NextLink>, 'href'> & {
  children: React.ReactNode;
  href: string;
};

/**
 * Thin wrapper over `next/link` that renders the anchor itself, so callers
 * pass anchor attributes (className, aria-label, data-cy) here rather than on
 * a nested `<a>`. Kept as the shared import point for the article cards.
 */
const Link = ({ children, href, ...anchorProps }: LinkProps) => {
  return (
    <NextLink href={href} {...anchorProps}>
      {children}
    </NextLink>
  );
};

export default Link;
